/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AttentionInputs */

const en__field_attention = /** @type {(inputs: _Field_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attention`)
};

const de__field_attention = /** @type {(inputs: _Field_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Händen`)
};

/**
* | output |
* | --- |
* | "Attention" |
*
* @param {_Field_AttentionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_attention = /** @type {((inputs?: _Field_AttentionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AttentionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_attention(inputs)
	return de__field_attention(inputs)
});